// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { PotentialOperationDetailsFragmentDoc, TradePartnerContactFragmentDoc, TradePartnerFragmentDoc, HistoryFeedInfoFragmentDoc, ChangeEventTypeFragmentDoc } from '../../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SendTradePartnerAvailabilityRequestEmailQueryVariables = Types.Exact<{
  currentDate: Types.Scalars['Date']['input'];
  twoWeeksFromToday: Types.Scalars['Date']['input'];
  scheduleParentId: Types.Scalars['ID']['input'];
}>;


export type SendTradePartnerAvailabilityRequestEmailQuery = { __typename?: 'Query', planTasks: { __typename?: 'PlanTasksResult', entities: Array<{ __typename?: 'PlanTask', id: string, name: string, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], tradePartner?: { __typename?: 'TradePartner', id: string, name: string, contactsForMarket: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined } | null | undefined> } | null | undefined, tradePartnerAvailabilityRequests?: Array<{ __typename?: 'TradePartnerAvailabilityRequest', id: string, createdAt: Types.Scalars['DateTime']['input'], tradePartner: { __typename?: 'TradePartner', id: string }, emails: Array<{ __typename?: 'TradePartnerAvailabilityRequestEmail', id: string }> }> | null | undefined, knownSchedulingContacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined }> }> }, planSchedule: { __typename?: 'PlanSchedule', id: string, canSendTradePartnerAvailabilityRequestEmail: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } };

export type SendSingleTradePartnerAvailabilityRequestEmailQueryVariables = Types.Exact<{
  planTaskId: Types.Scalars['ID']['input'];
  scheduleParentId: Types.Scalars['ID']['input'];
}>;


export type SendSingleTradePartnerAvailabilityRequestEmailQuery = { __typename?: 'Query', planTask: { __typename?: 'PlanTask', id: string, name: string, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], tradePartner?: { __typename?: 'TradePartner', id: string, name: string, contactsForMarket: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined } | null | undefined> } | null | undefined, tradePartnerAvailabilityRequests?: Array<{ __typename?: 'TradePartnerAvailabilityRequest', id: string, createdAt: Types.Scalars['DateTime']['input'], tradePartner: { __typename?: 'TradePartner', id: string }, emails: Array<{ __typename?: 'TradePartnerAvailabilityRequestEmail', id: string }> }> | null | undefined, knownSchedulingContacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined }> }, planSchedule: { __typename?: 'PlanSchedule', id: string, canSendTradePartnerAvailabilityRequestEmail: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } };

export type SaveTradePartnerAvailabilityRequestsMutationVariables = Types.Exact<{
  input: Array<Types.SaveTradePartnerAvailabilityRequestInput> | Types.SaveTradePartnerAvailabilityRequestInput;
}>;


export type SaveTradePartnerAvailabilityRequestsMutation = { __typename?: 'Mutation', saveTradePartnerAvailabilityRequests: { __typename?: 'SaveTradePartnerAvailabilityRequestsResult', tradePartnerAvailabilityRequests: Array<{ __typename?: 'TradePartnerAvailabilityRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string } }> } };

export type SendTradePartnerAvailabilityRequestEmail_PlanTaskFragment = { __typename?: 'PlanTask', id: string, name: string, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], tradePartner?: { __typename?: 'TradePartner', id: string, name: string, contactsForMarket: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined } | null | undefined> } | null | undefined, tradePartnerAvailabilityRequests?: Array<{ __typename?: 'TradePartnerAvailabilityRequest', id: string, createdAt: Types.Scalars['DateTime']['input'], tradePartner: { __typename?: 'TradePartner', id: string }, emails: Array<{ __typename?: 'TradePartnerAvailabilityRequestEmail', id: string }> }> | null | undefined, knownSchedulingContacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined }> };

export type SendTradePartnerAvailabilityRequestEmail_TradePartnerFragment = { __typename?: 'TradePartner', id: string, name: string, contactsForMarket: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined } | null | undefined> };

export type SendTradePartnerAvailabilityRequestEmail_TradePartnerMarketContactFragment = { __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: Types.TradePartnerMarketRole }, contact: { __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined } };

export type SendTradePartnerAvailabilityRequestEmail_TradePartnerContactFragment = { __typename?: 'TradePartnerContact', id: string, name: string, email?: string | null | undefined };

export type SendTradePartnerAvailabilityRequestEmail_TradePartnerAvailabilityRequestFragment = { __typename?: 'TradePartnerAvailabilityRequest', id: string, createdAt: Types.Scalars['DateTime']['input'], tradePartner: { __typename?: 'TradePartner', id: string }, emails: Array<{ __typename?: 'TradePartnerAvailabilityRequestEmail', id: string }> };

export const SendTradePartnerAvailabilityRequestEmail_TradePartnerContactFragmentDoc = gql`
    fragment SendTradePartnerAvailabilityRequestEmail_TradePartnerContact on TradePartnerContact {
  id
  name
  email
}
    `;
export const SendTradePartnerAvailabilityRequestEmail_TradePartnerFragmentDoc = gql`
    fragment SendTradePartnerAvailabilityRequestEmail_TradePartner on TradePartner {
  id
  name
  contactsForMarket(projectDevelopmentMarketId: $scheduleParentId) {
    ...SendTradePartnerAvailabilityRequestEmail_TradePartnerContact
  }
}
    ${SendTradePartnerAvailabilityRequestEmail_TradePartnerContactFragmentDoc}`;
export const SendTradePartnerAvailabilityRequestEmail_TradePartnerAvailabilityRequestFragmentDoc = gql`
    fragment SendTradePartnerAvailabilityRequestEmail_TradePartnerAvailabilityRequest on TradePartnerAvailabilityRequest {
  id
  createdAt
  tradePartner {
    id
  }
  emails {
    id
  }
}
    `;
export const SendTradePartnerAvailabilityRequestEmail_PlanTaskFragmentDoc = gql`
    fragment SendTradePartnerAvailabilityRequestEmail_PlanTask on PlanTask {
  id
  name
  startDate
  endDate
  tradePartner {
    ...SendTradePartnerAvailabilityRequestEmail_TradePartner
  }
  tradePartnerAvailabilityRequests {
    ...SendTradePartnerAvailabilityRequestEmail_TradePartnerAvailabilityRequest
  }
  knownSchedulingContacts {
    ...SendTradePartnerAvailabilityRequestEmail_TradePartnerContact
  }
}
    ${SendTradePartnerAvailabilityRequestEmail_TradePartnerFragmentDoc}
${SendTradePartnerAvailabilityRequestEmail_TradePartnerAvailabilityRequestFragmentDoc}
${SendTradePartnerAvailabilityRequestEmail_TradePartnerContactFragmentDoc}`;
export const SendTradePartnerAvailabilityRequestEmail_TradePartnerMarketContactFragmentDoc = gql`
    fragment SendTradePartnerAvailabilityRequestEmail_TradePartnerMarketContact on TradePartnerMarketContact {
  id
  role {
    code
  }
  contact {
    ...SendTradePartnerAvailabilityRequestEmail_TradePartnerContact
  }
}
    ${SendTradePartnerAvailabilityRequestEmail_TradePartnerContactFragmentDoc}`;
export const SendTradePartnerAvailabilityRequestEmailDocument = gql`
    query SendTradePartnerAvailabilityRequestEmail($currentDate: Date!, $twoWeeksFromToday: Date!, $scheduleParentId: ID!) {
  planTasks(
    filter: {scheduleParent: [$scheduleParentId], tradePartnerStatus: [NEEDS_CONFIRMATION, NOT_SENT], startDateRange: {value: $twoWeeksFromToday, op: ON_OR_BEFORE}, endDateRange: {value: $currentDate, op: ON_OR_AFTER}}
  ) {
    entities {
      ...SendTradePartnerAvailabilityRequestEmail_PlanTask
    }
  }
  planSchedule(idOrScheduleParentId: $scheduleParentId) {
    id
    canSendTradePartnerAvailabilityRequestEmail {
      ...PotentialOperationDetails
    }
  }
}
    ${SendTradePartnerAvailabilityRequestEmail_PlanTaskFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;

/**
 * __useSendTradePartnerAvailabilityRequestEmailQuery__
 *
 * To run a query within a React component, call `useSendTradePartnerAvailabilityRequestEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendTradePartnerAvailabilityRequestEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendTradePartnerAvailabilityRequestEmailQuery({
 *   variables: {
 *      currentDate: // value for 'currentDate'
 *      twoWeeksFromToday: // value for 'twoWeeksFromToday'
 *      scheduleParentId: // value for 'scheduleParentId'
 *   },
 * });
 */
export function useSendTradePartnerAvailabilityRequestEmailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SendTradePartnerAvailabilityRequestEmailQuery, SendTradePartnerAvailabilityRequestEmailQueryVariables> & ({ variables: SendTradePartnerAvailabilityRequestEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SendTradePartnerAvailabilityRequestEmailQuery, SendTradePartnerAvailabilityRequestEmailQueryVariables>(SendTradePartnerAvailabilityRequestEmailDocument, options);
      }
export function useSendTradePartnerAvailabilityRequestEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SendTradePartnerAvailabilityRequestEmailQuery, SendTradePartnerAvailabilityRequestEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SendTradePartnerAvailabilityRequestEmailQuery, SendTradePartnerAvailabilityRequestEmailQueryVariables>(SendTradePartnerAvailabilityRequestEmailDocument, options);
        }
export function useSendTradePartnerAvailabilityRequestEmailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SendTradePartnerAvailabilityRequestEmailQuery, SendTradePartnerAvailabilityRequestEmailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SendTradePartnerAvailabilityRequestEmailQuery, SendTradePartnerAvailabilityRequestEmailQueryVariables>(SendTradePartnerAvailabilityRequestEmailDocument, options);
        }
export type SendTradePartnerAvailabilityRequestEmailQueryHookResult = ReturnType<typeof useSendTradePartnerAvailabilityRequestEmailQuery>;
export type SendTradePartnerAvailabilityRequestEmailLazyQueryHookResult = ReturnType<typeof useSendTradePartnerAvailabilityRequestEmailLazyQuery>;
export type SendTradePartnerAvailabilityRequestEmailSuspenseQueryHookResult = ReturnType<typeof useSendTradePartnerAvailabilityRequestEmailSuspenseQuery>;
export type SendTradePartnerAvailabilityRequestEmailQueryResult = Apollo.QueryResult<SendTradePartnerAvailabilityRequestEmailQuery, SendTradePartnerAvailabilityRequestEmailQueryVariables>;
export const SendSingleTradePartnerAvailabilityRequestEmailDocument = gql`
    query SendSingleTradePartnerAvailabilityRequestEmail($planTaskId: ID!, $scheduleParentId: ID!) {
  planTask(id: $planTaskId) {
    ...SendTradePartnerAvailabilityRequestEmail_PlanTask
  }
  planSchedule(idOrScheduleParentId: $scheduleParentId) {
    id
    canSendTradePartnerAvailabilityRequestEmail {
      ...PotentialOperationDetails
    }
  }
}
    ${SendTradePartnerAvailabilityRequestEmail_PlanTaskFragmentDoc}
${PotentialOperationDetailsFragmentDoc}`;

/**
 * __useSendSingleTradePartnerAvailabilityRequestEmailQuery__
 *
 * To run a query within a React component, call `useSendSingleTradePartnerAvailabilityRequestEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendSingleTradePartnerAvailabilityRequestEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendSingleTradePartnerAvailabilityRequestEmailQuery({
 *   variables: {
 *      planTaskId: // value for 'planTaskId'
 *      scheduleParentId: // value for 'scheduleParentId'
 *   },
 * });
 */
export function useSendSingleTradePartnerAvailabilityRequestEmailQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SendSingleTradePartnerAvailabilityRequestEmailQuery, SendSingleTradePartnerAvailabilityRequestEmailQueryVariables> & ({ variables: SendSingleTradePartnerAvailabilityRequestEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SendSingleTradePartnerAvailabilityRequestEmailQuery, SendSingleTradePartnerAvailabilityRequestEmailQueryVariables>(SendSingleTradePartnerAvailabilityRequestEmailDocument, options);
      }
export function useSendSingleTradePartnerAvailabilityRequestEmailLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SendSingleTradePartnerAvailabilityRequestEmailQuery, SendSingleTradePartnerAvailabilityRequestEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SendSingleTradePartnerAvailabilityRequestEmailQuery, SendSingleTradePartnerAvailabilityRequestEmailQueryVariables>(SendSingleTradePartnerAvailabilityRequestEmailDocument, options);
        }
export function useSendSingleTradePartnerAvailabilityRequestEmailSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SendSingleTradePartnerAvailabilityRequestEmailQuery, SendSingleTradePartnerAvailabilityRequestEmailQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SendSingleTradePartnerAvailabilityRequestEmailQuery, SendSingleTradePartnerAvailabilityRequestEmailQueryVariables>(SendSingleTradePartnerAvailabilityRequestEmailDocument, options);
        }
export type SendSingleTradePartnerAvailabilityRequestEmailQueryHookResult = ReturnType<typeof useSendSingleTradePartnerAvailabilityRequestEmailQuery>;
export type SendSingleTradePartnerAvailabilityRequestEmailLazyQueryHookResult = ReturnType<typeof useSendSingleTradePartnerAvailabilityRequestEmailLazyQuery>;
export type SendSingleTradePartnerAvailabilityRequestEmailSuspenseQueryHookResult = ReturnType<typeof useSendSingleTradePartnerAvailabilityRequestEmailSuspenseQuery>;
export type SendSingleTradePartnerAvailabilityRequestEmailQueryResult = Apollo.QueryResult<SendSingleTradePartnerAvailabilityRequestEmailQuery, SendSingleTradePartnerAvailabilityRequestEmailQueryVariables>;
export const SaveTradePartnerAvailabilityRequestsDocument = gql`
    mutation SaveTradePartnerAvailabilityRequests($input: [SaveTradePartnerAvailabilityRequestInput!]!) {
  saveTradePartnerAvailabilityRequests(input: $input) {
    tradePartnerAvailabilityRequests {
      id
      tradePartner {
        id
      }
    }
  }
}
    `;
export type SaveTradePartnerAvailabilityRequestsMutationFn = Apollo.MutationFunction<SaveTradePartnerAvailabilityRequestsMutation, SaveTradePartnerAvailabilityRequestsMutationVariables>;

/**
 * __useSaveTradePartnerAvailabilityRequestsMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerAvailabilityRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerAvailabilityRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerAvailabilityRequestsMutation, { data, loading, error }] = useSaveTradePartnerAvailabilityRequestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerAvailabilityRequestsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerAvailabilityRequestsMutation, SaveTradePartnerAvailabilityRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerAvailabilityRequestsMutation, SaveTradePartnerAvailabilityRequestsMutationVariables>(SaveTradePartnerAvailabilityRequestsDocument, options);
      }
export type SaveTradePartnerAvailabilityRequestsMutationHookResult = ReturnType<typeof useSaveTradePartnerAvailabilityRequestsMutation>;
export type SaveTradePartnerAvailabilityRequestsMutationResult = Apollo.MutationResult<SaveTradePartnerAvailabilityRequestsMutation>;
export type SaveTradePartnerAvailabilityRequestsMutationOptions = Apollo.BaseMutationOptions<SaveTradePartnerAvailabilityRequestsMutation, SaveTradePartnerAvailabilityRequestsMutationVariables>;